import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProjectListItem from "./ProjectListItem";
import { projectService, Proyecto } from "api/projectService";
import { getRlLevel } from "global/util/calculadora";

export interface Evaluation {
  id: string;
  name: string;
  brl: number;
  trl: number;
  iprl: number;
  tmrl: number;
  frl: number;
}

function Proyect() {
  const [projects, setProjects] = useState<Proyecto[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate()
  const exampleProjects = [{
    id: "1",
    title: "Tecnología Alpha",
    description: "Descripción de la tecnología",
    owner: "Carlos",
    evaluations: [
      { id: "eva1", name: "Evaluación 1", brl: 1, trl: 2, iprl: 3, tmrl: 4, frl: 5 },
      { id: "eva2", name: "Evaluación 2", brl: 1, trl: 2, iprl: 3, tmrl: 4, frl: 5 },
      { id: "eva3", name: "Evaluación 3", brl: 1, trl: 2, iprl: 3, tmrl: 4, frl: 5 }
    ]
  }];

  useEffect(() => {

    const fetchProjects = async () => {
      try {
        setLoading(true);
        const proyectos = await projectService.listar();
        //console.log("Proyectos listados:", JSON.stringify(proyectos));
        setProjects(proyectos); // Guardar proyectos en el estado
      } catch (error) {
        console.error("Error al listar proyectos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [])

  return (
    <div className="containerMultipleChoiceTabs">
      {loading ?
        <div className="mxAuto">
          Cargando...
        </div>
        :
        <div className="mxAuto">
          <div className="projectCard">
            <div className="projectCardHeader">
              {/**
              <div>HUBTEC, KNOWHUB y APTA, con apoyo de ANID, han desarrollado una plataforma que permite medir el nivel de madurez de un proyecto de innovación no solo enfocándose en el nivel de desarrollo tecnológico sino que en distintas dimensiones que son relevantes para su transferencia tecnológica. El desarrollo de esta herramienta se basa en el modelo KTH Innovation Readiness Level, desarrollado por KTH Innovation.
              </div>
               */}
              <div>
                <img className="fullWidthImg" src={`/images/go/Proceso.png`} />

              </div>
            </div>
            <div className="headerRow">
              <div className="title">Mis Proyectos</div>
              {/* 2) Descripción */}
              <div className="description"></div>
              {/* 3) Propietario */}
              <div className="owner">
                <div className="showMoreButtonContainer">
                  <button onClick={() => { navigate(`/evaluacion`) }} className="showMoreButton">
                    Nuevo proyecto
                  </button>
                </div>
              </div>
            </div>


            {
              projects.length === 0 ?

                <div className="projectCard">
                  Para comenzar a evaluar un Proyecto presiona aquí:
                  <div className="showMoreButtonContainer">
                    <button onClick={() => { navigate(`/evaluacion`) }} className="showMoreButton">
                      Comenzar
                    </button>
                  </div>
                </div>
                :
                <div>

                  {
                    projects.map((p) => {
                      const project = {
                        id: p.idProyecto + "",
                        title: p.nombre,
                        description: p.nombreTipoProyecto,
                        owner: p.nombreContacto,
                        originalProject: p,
                        evaluations: p.evaluaciones?.map((e) => {
                          const crl = e.rls.find(rl => rl.rl === "CRL");
                          const crlLevel = getRlLevel(crl);

                          const brl = e.rls.find(rl => rl.rl === "BRL");
                          const brlLevel = getRlLevel(brl);

                          const trl = e.rls.find(rl => rl.rl === "TRL");
                          const trlLevel = getRlLevel(trl);

                          const iprl = e.rls.find(rl => rl.rl === "IPRL");
                          const iprlLevel = getRlLevel(iprl);

                          const tmrl = e.rls.find(rl => rl.rl === "TmRL");
                          const tmrlLevel = getRlLevel(tmrl);

                          const frl = e.rls.find(rl => rl.rl === "FRL");
                          const frlLevel = getRlLevel(frl);

                          // console.log("BRL:", brlLevel);
                          // console.log("TRL:", trlLevel);
                          // console.log("TmRL:", tmrlLevel);
                          // console.log("IPRL:", iprlLevel);
                          // console.log("FRL:", frlLevel);
                          return (
                            {
                              id: e.id + "",
                              name: new Date(e.fechaEvaluacion ?? new Date()).toLocaleDateString("es-CL", { day: "2-digit", month: "2-digit", year: "numeric" }),
                              activa: e.activa,
                              crl: crlLevel ?? 1,
                              brl: brlLevel ?? 1,
                              trl: trlLevel ?? 1,
                              iprl: iprlLevel ?? 1,
                              tmrl: tmrlLevel ?? 1,
                              frl: frlLevel ?? 1
                            }
                          )
                        })
                      }
                      return (
                        <ProjectListItem project={project} />
                      )
                    })
                  }
                </div>
            }

          </div>
        </div>
      }
    </div>
  );
}

export default Proyect;